import { date, relation, children } from '@nozbe/watermelondb/decorators';
import { WISHLIST_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class Payment extends Model {
    static table = WISHLIST_SCHEMA;

    static associations = {
        user: { type: 'belongs_to', key: 'user_id' },
        wishlist_items: { type: 'has_many', foreignKey: 'wishlist_id' },
    }

    @date('created_at') created_at;

    @relation('user', 'user_id') user;
    @children('wishlist_items') wishlist_items;
};